import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UserRoleEnum } from 'src/app/common/services/auth/enums/user-role.enum';
import { StorageService } from 'src/app/common/services/storage/storage.service';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { GetClientsResponse } from '../../models/client.model';

@Component({
  selector: 'app-client-list-item',
  templateUrl: './client-list-item.component.html',
  styleUrls: ['./client-list-item.component.scss'],
})
export class ClientListItemComponent {
  hasSupervisorRole: boolean = false;

  ButtonColorEnum = ButtonColorEnum;

  @Input() data: GetClientsResponse = {
    id: '',
    name: '',
    cnpj: '',
    active: false,
    creationDate: '',
    skills: [],
    holdingLineTime: '',
    readinessTimeExceeded: '',
    returnTimeExceeded: '',
    minimumCallTime: '',
    shifts: null,
  };

  constructor(
    private readonly storageService: StorageService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const role = this.storageService.getRole();
    this.hasSupervisorRole = role === UserRoleEnum.supervisor;
  }

  handleDetails(id: string) {
    this.router.navigate(['/client/', id]);
  }

  formatCNPJ(cnpj: string) {
    cnpj = cnpj.replace(/\D/g, ''); // Remove tudo o que não é dígito

    if (cnpj.length === 14) {
      cnpj = cnpj.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
      );
    }

    return cnpj;
  }
}
